import Vue from 'vue';
import { mapGetters } from 'vuex';
import { formatDate } from '@/mixins/format-date';
import { cognitoMixins } from '@storm/mixins/cognito';
import SettingsModal from './settings-modal';

export default Vue.component('storm-global', {
  template: require('./template.html'),
  name: 'storm-global',
  mixins: [formatDate, cognitoMixins],
  computed: {
    ...mapGetters(['stormSession', 'stormUser']),
  },
  components: {
    SettingsModal,
  },
  data() {
    return {
      loading: false,
      openSettings: false,
      modalContent: false,
    };
  },
  created() {
    // reset current user first
    this.$store.dispatch('setCurrentUser', false);
    this.getPricingData();
    this.checkSession();
  },
  methods: {
    async checkSession() {
      this.loading = true;
      try {
        const session = await this.cognitoValidateSession();
        if (session) {
          const attrs = await this.cognitoGetUserAttrs();
          this.setStormUserState(attrs);
          await this.setStormUserData(session);
        } else {
          // route to login screen if no session set
          this.$router.push({ path: '/storm-login' });
        }
      } catch (e) {
        const message = e.message || e.body || e;
        this.$log.error(message);
        if (message === 'User does not exist.') {
          await this.logout();
          this.$router.push({ path: '/storm-login' });
        }
      } finally {
        this.loading = false;
      }
    },
    setStormUserState(attrs) {
      const user = {};
      attrs.forEach((attr) => {
        if (attr.Name.match(/^custom:/)) {
          user[attr.Name.replace(/^custom:/gi, '')] = attr.Value;
        } else {
          user[attr.Name] = attr.Value;
        }
      });
      this.$log.debug(`Storm session set for: ${user.email}`);
      this.$store.dispatch('setStormUser', user);
    },
    async setStormUserData(session) {
      this.$store.dispatch('setStormSession', { session });
    },
    async getPricingData() {
      const data = await this.$http.get(`${process.env.S3_ASSETS_BUCKET}info/pricing-data.json`);
      this.$store.dispatch('setPriceSource', {
        data: data.body,
      });
    },
    ticketPath(path) {
      return path.match(/^\/storm-tickets/);
    },
    setModal(content) {
      this.modalContent = content;
      this.openSettings = false;
    },
    async logout() {
      try {
        this.loading = true;
        await this.cognitoLogout();
        this.clearCognitoKeys();
        this.$store.dispatch('setStormUser', {});
        this.$store.dispatch('setStormSession', { session: {} });
        this.$router.push({ path: '/storm-login' });
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.loading = false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/index.js